<template>
<div class="doc_tabdiv">
    <div class="doctab_flex-div">
        <div class="doctab_textdiv">
            
            <div class="doctab_toptextdiv">
                <div class="text-block-1262">Doctor on Demand</div>
                <div class="text-block-1263 mobile"><span class="text-span-277">Response time is less than 24 hours.</span><br>We will notify you by text when they respond.</div>
            </div>
            <div v-if="doctorProfile" class="doctor-profile-div">
                <div class="div-block-1989">
                    <div class="doc_picdiv" style="background-color: #fff;">
                        <img
                                :src="doctorProfile.image || require('@/assets/images/doctor-svgrepo-com.svg')"
                                loading="lazy"
                                alt="Doctor profile"
                                />
                    </div>
                    <div class="doc_namediv">
                        <div class="text-block-1277">Dr. {{ doctorProfile.name || '' }}</div>
                        <div class="doc_npi_div">
                            <div class="text-block-1278">NPI#:</div>
                            <div class="text-block-1279">{{ doctorProfile.npi || '' }}</div>
                        </div>
                    </div>

                </div>
                <p class="paragraph-164" style="padding-bottom: 20px;">{{ doctorProfile.bio || '' }}</p>
                <div class="show-on-mobile">
                    <a href="#" class="link-block-84 w-inline-block " @click.prevent="toggleDoctorChat()">
                        <div class="text-block-1280">Send Message</div><img loading="lazy" src="@/assets/images/icon_SMS.svg" alt="" class="image-556">
                    </a>
                </div>
            </div>
            <p class="paragraph-162">Use this chat to ask your doctor questions about your treatments, side effects and any other medical questions you may have.</p>
            <div class="text-block-1263 desk"><span class="text-span-277">Response time is less than 24 hours.</span><br>We will notify you by text when they respond.</div>
            <div class="div-block-1988 ">
                <div class="text-block-1264">If you have billing, shipping, customer service, pharmacy or any other questions please click the button below</div>
                <a href="#" class="button-125 w-button" style="display: block;" @click.prevent="showChatWindow()">Chat with Customer Service</a>
            </div>
        </div>
        <div class="doctab_chat-div">
            <div class="w-embed" ref="dochatmdi"  v-if="shouldShowDocChat">
                <iframe src="https://patient.mdintegrations.com/tabs/messages?fullscreen=true" style="height:80vh; width: 100%; min-height: 450px;border: none;"></iframe>
            </div>
            <div class="w-embed" v-else>
                <docChat :encounterId="currentEncounterId"/>
            </div>
            
        </div>
    </div>
</div>
</template>
<script>
import {
    mapGetters
} from 'vuex';
import docChat from '../chat/docChat.vue'
export default {
    props: {
        baseUrl: {
            type: String,
            required: true
        }
    },
    components: {
        docChat
    },
    data() {
        return {
            doctorProfile: null,
            loading: true,
            error: null,
            showmobile:true,
        }
    },

    computed: {
        ...mapGetters(['getCase', 'docProfile','getLatestEncounter']),
        
        // Make these computed properties reactive to store changes
        shouldShowDocChat() {
            // Check if we have a valid encounter with provider 1
            return this.getLatestEncounter && this.getLatestEncounter.provider === 1;
        },
        
        currentEncounterId() {
            // Return the encounter ID if available
            return this.getLatestEncounter ? this.getLatestEncounter.encounter_id : null;
        }
    },

    watch: {
        // Watch for changes in case ID and provider
        getCase: {
            immediate: true,
            deep: true,
            handler(newCase) {
                if (newCase && newCase.id && newCase.provider === 1) {
                    this.fetchDoctorProfile();
                }
            }
        },

        // Watch for changes in docProfile from Vuex
        docProfile: {
            immediate: true,
            handler(newProfile) {
                if (newProfile) {
                    this.doctorProfile = newProfile;
                    this.loading = false;
                }
            }
        },

        // Watch for changes in encounter data
        getLatestEncounter: {
            immediate: true,
            deep: true,
            handler() {
               
                this.$forceUpdate();
            }
        }
    },

    methods: {
        showChatWindow() {
            this.$root.$emit('toggle-chat');
        },
        async toggleDoctorChat() {
            if (this.shouldShowDocChat) {
                // If MDI chat is active, toggle it via store action
                await this.$store.dispatch('toggeleDocChat');
                
                // Scroll to MDI iframe
                this.$nextTick(() => {
                    setTimeout(() => {
                        const el = this.$refs.dochatmdi;
                        if (el && el.scrollIntoView) {
                            console.log("scrolling to MDI iframe");
                            el.scrollIntoView({ behavior: 'smooth', block: 'center' });
                        } else {
                            console.warn('MDI iframe element not found for scrolling');
                        }
                    }, 200); 
                });
            } else {
                await this.$store.dispatch('toggeleDocChat');
            }
        },
        async fetchDoctorProfile() {
            try {
                // Check if we already have a valid doctor profile in Vuex
                
                // Validate case ID exists
                if (!this.currentEncounterId) {
                    console.log("no case id")
                    throw new Error('No valid case ID found');
                }

                this.loading = true;
                const response = await this.$axios.get(`${this.baseUrl}/api/get-doc-profile/${this.currentEncounterId}`);

                // Validate response structure
                if (!response?.data?.status || response.data.status !== 'success' || !response.data.case) {
                    throw new Error('Invalid response structure from API');
                }

                const profileData = response.data.case;

                // Validate required profile fields
                if (!profileData.name || !profileData.npi) {
                    throw new Error('Incomplete doctor profile data');
                }

                // Update Vuex store and local state
                await this.$store.dispatch('setDocProfile', profileData);
                this.doctorProfile = profileData;

            } catch (error) {
                console.error('Error fetching doctor profile:', error);
                this.error = error.message || 'Failed to load doctor profile';
                this.doctorProfile = null;
            } finally {
                this.loading = false;
            }
        }
    },

    async created() {
        await this.fetchDoctorProfile();
    },
    // Add mounted hook to ensure we have the latest data when tab becomes active
    mounted() {
        
    },
    // Add activated hook for keep-alive components (if you're using keep-alive)
    activated() {
        console.log('talkToDoc activated, current encounter:', this.getLatestEncounter);
        // Force update when tab becomes active
        this.$nextTick(() => {
            this.$forceUpdate();
        });
    }
}
</script>

<style>
.show-on-mobile {
        display: none;
    }
@media (max-width: 768px) {
    .show-on-mobile {
        display: block;
    }
}

@media screen and (max-width: 479px) {
    .doctab_flex-div {
        flex-flow: column;
    }
}

.doctab_flex-div {
    justify-content: space-between;
    padding-top: 50px;
    display: flex;
}

.doctab_textdiv {
    width: 35%;
}

.doctab_chat-div {
    border: 1px solid var(--f3-grey);
    width: 60%;
}

@media screen and (max-width: 479px) {
    .doctab_chat-div {
        border: 1px solid var(--f3-grey);
        width: 100%;
    }
}

@media screen and (max-width: 479px) {
    .doctab_textdiv {
        width: 100%;
        margin-bottom: 30px;
    }
}

@media screen and (max-width: 479px) {
    .image-550 {
        width: 35px;
        margin-bottom: 15px;
    }
}

.image-550 {
    width: 50px;
    margin-bottom: 30px;
}

@media screen and (max-width: 479px) {
    .doctab_toptextdiv {
        flex-flow: column;
        justify-content: space-between;
        display: flex;
    }
}

@media screen and (max-width: 479px) {
    .text-block-1262 {
        margin-bottom: 15px;
        font-size: 30px;
        line-height: 36px;
    }
}

.text-block-1262 {
    font-family: var(--mulish);
    color: var(--black);
    margin-bottom: 20px;
    font-size: 30px;
    font-weight: 900;
    line-height: 36px;
}

@media screen and (max-width: 479px) {
    .text-block-1263.mobile {
        width: auto;
        font-size: 13px;
        line-height: 16px;
        display: none;
    }
}

.text-block-1263.mobile {
    display: none;
    overflow: visible;
}

.text-span-277 {
    font-weight: 900;
}

.doctor-profile-div {
    background-color: var(--f3-grey);
    border-radius: 9px;
    margin-bottom: 20px;
    padding: 20px;
}

.div-block-1989 {
    grid-column-gap: 10px;
    grid-row-gap: 10px;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 10px;
    display: flex;
}

.doc_picdiv {
    background-color: var(--pastel-blue);
    border-radius: 100px;
    width: 50px;
    height: 50px;
    overflow: hidden;
}

.text-block-1277 {
    font-family: var(--inter);
    color: var(--black);
    margin-bottom: 3px;
    font-size: 14px;
    font-weight: 900;
}

.doc_npi_div {
    grid-column-gap: 5px;
    grid-row-gap: 5px;
    justify-content: flex-start;
    align-items: flex-start;
    display: flex;
}

.text-block-1278 {
    font-family: var(--inter);
    color: var(--black);
    font-size: 13px;
    font-weight: 900;
    line-height: 15px;
}

.text-block-1279 {
    font-family: var(--inter);
    color: var(--black);
    font-size: 13px;
    line-height: 15px;
}

.paragraph-164 {
    color: var(--black);
    margin-bottom: 0;
    font-size: 12px;
    line-height: 15px;
}

.paragraph-162 {
    color: var(--black);
    margin-bottom: 20px;
    font-size: 18px;
    line-height: 24px;
}

.text-block-1263.desk {
    font-size: 15px;
    line-height: 21px;
}

.text-block-1263 {
    color: var(--black);
    font-size: 18px;
    line-height: 24px;
}

.text-span-277 {
    font-weight: 900;
}

.div-block-1988 {
    background-color: var(--pastel-blue);
    margin-top: 30px;
    padding: 20px;
}

.text-block-1264 {
    font-family: var(--mulish);
    color: var(--white);
    margin-bottom: 20px;
    font-size: 15px;
    font-weight: 400;
    line-height: 22px;
}

.button-125 {
    background-color: var(--black);
    font-family: var(--mulish);
    color: var(--white);
    text-align: center;
    border-radius: 9px;
    width: 100%;
    padding-top: 15px;
    padding-bottom: 15px;
    font-size: 15px;
    font-weight: 600;
}
</style>
